export const config = {
  title: "Cynthia Mangini | CENTURY 21 AllPoints Realty",
  meta: {
    description:
      "Cynthia Mangini is a trusted real estate professional with CENTURY 21 AllPoints Realty, serving Enfield, CT and surrounding areas. Fluent in English and Spanish.",
    keywords: [
      "Cynthia Mangini",
      "Century 21 AllPoints Realty",
      "Enfield CT Realtor",
      "Homes for Sale Enfield CT",
      "Bilingual Real Estate Agent"
    ],
    author: "Cynthia Mangini",
    canonicalUrl: "https://www.cynthiaforsalehomes.com/",
  },
  sections: {
    header: {
      businessName: "Cynthia Mangini | CENTURY 21 AllPoints Realty",
    },
    sectionB: {
      heroTitle: "Cynthia Mangini",
      heroSubtitle: "Your Enfield, CT Real Estate Expert",
      learnAboutText: "Explore Listings",
      phoneNumber: "8609301483",
      phoneLabel: "(860) 930‑1483",
      heroBackgroundImage:
        "https://images.marketleader.com/assets/75/2405075_40438439_f.jpg",
      cardData: [
        {
          title: "Buying a Home",
          description:
            "Receive expert guidance in finding and purchasing your dream home.",
        },
        {
          title: "Selling a Home",
          description:
            "Get top value for your property with personalized marketing strategies.",
        },
        {
          title: "Market Analysis",
          description:
            "Use accurate, up-to-date analysis to make informed real estate decisions.",
        },
      ],
      description:
        "With CENTURY 21 AllPoints Realty, Cynthia Mangini offers exceptional real estate services across Enfield, CT and nearby areas. Fluent in English and Spanish, she is committed to exceeding clients' expectations in both buying and selling processes."  
    },
    sectionC: {
      servicesTitle: "Services Offered",
      servicesDescription:
        "Comprehensive real estate services customized for buyers and sellers.",
      cards: [
        {
          title: "Home Buyer Representation",
          description:
            "Guided support through each step of the homebuying process.",
          imageSrc: "https://media.istockphoto.com/id/2151912551/photo/building-contractor-talking-to-clients-renovating-their-house.jpg?s=612x612&w=0&k=20&c=QhL8-C4dGz4ATIhLTaFYD_tKjHTLAKWZIBsuBW_n-ms=",
          imageAlt: "Home Buying Services",
        },
        {
          title: "Home Seller Marketing",
          description:
            "Professional listing services for maximum visibility and value.",
          imageSrc: "https://media.istockphoto.com/id/648727544/photo/doorstep-advice.jpg?s=612x612&w=0&k=20&c=R8ea3LCWUR1bRtqTtSYLtfqv4F-YhJnFn_8JkyAyBpA=",
          imageAlt: "Home Selling Services",
        },
        {
          title: "Community & Market Insights",
          description:
            "Benefit from Cynthia’s deep knowledge of Enfield and surrounding CT communities.",
          imageSrc: "https://media.istockphoto.com/id/2198704639/photo/vibrant-scene-at-venice-beach-with-bicycles-and-palm-trees.jpg?s=612x612&w=0&k=20&c=LCk-p2AjfVCNAdptsAFYIU5kI643sMEr2755bw5dU5A=",
          imageAlt: "Local Market Knowledge",
        },
      ],
      otherServicesTitle: "Additional Offerings",
      otherServicesList: [
        "Relocation Assistance",
        "Investment Property Guidance",
        "Open House Coordination",
        "Real Estate Negotiation Support",
        "Bilingual Real Estate Services",
      ],
    },
    sectionD: {
      aboutTitle: "About Cynthia",
      aboutImage: {
        src:
          "https://images.marketleader.com/MarketingImages/68/2405268_normal.jpg",
        alt: "Cynthia Mangini",
      },
      aboutText: [
        "With over 20 years of experience, Cynthia Mangini is a bilingual (English and Spanish) real estate agent dedicated to helping families find their dream home or sell with confidence.",
        "Representing CENTURY 21 AllPoints Realty, she serves Enfield, CT and the surrounding areas with unmatched commitment, local market insight, and a client-first approach."
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Cynthia Mangini Portrait",
      businessName: "Cynthia Mangini | CENTURY 21 AllPoints Realty",
      contact: {
        phone: "8609301483",
        phoneLabel: "(860) 930‑1483",
        email: "cman555499@aol.com",
        website: "https://www.cynthiaforsalehomes.com/",
        address: "265 Hazard Ave, Enfield, CT 06082",
      },
      socialMedia: {
        facebook: null,
        instagram: null,
        twitter: null,
        linkedin: null,
        youtube: null,
      },
    },
    sectionF: {
      address: "265 Hazard Ave, Enfield, CT 06082",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2906.152780363679!2d-72.56762858473178!3d42.00622007921156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89e6e0a8d2d1de87%3A0x55fa6c2442e148a0!2s265%20Hazard%20Ave%2C%20Enfield%2C%20CT%2006082%2C%20USA!5e0!3m2!1sen!2sus!4v1718531850000!5m2!1sen!2sus",
    }
  },
};

export default config;
